export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-de-d46c6623.png'